"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAxiosError = exports.isError = void 0;
function isError(e) {
    var _a;
    return ((_a = e) === null || _a === void 0 ? void 0 : _a.message) !== undefined;
}
exports.isError = isError;
/**
 * This is the AxiosError interface from axios.
 *
interface AxiosError extends Error {
  config: AxiosRequestConfig;
  code?: string;
  request?: any;
  response?: AxiosResponse;
}
 */
/**
 * Returns true if the object is of type AxiosError
 * @param e Error
 * @returns
 */
function isAxiosError(e) {
    var _a, _b;
    const hasConfig = e.config !== undefined;
    const hasCode = ((_a = e) === null || _a === void 0 ? void 0 : _a.code) !== undefined;
    const hasResponse = ((_b = e) === null || _b === void 0 ? void 0 : _b.response) !== undefined;
    return hasConfig && (hasCode || hasResponse);
}
exports.isAxiosError = isAxiosError;
//# sourceMappingURL=error.types.js.map